<div class="div_menu_items">
    <div class="pos-title-header">
        <label class="lbl_top">{{'MENU_ITEM.MENU_ITEMS' | translate}}</label>
        <div>
          <span class="hide_mobile">
            <button class="create_btn" (click)="createMenuItem(MenuItemTypeEnum.Drink)">
              <span class="hide_mobile">{{'MENU_ITEM.ADD_DRINKS' | translate}}</span>
            </button>
            <button class="create_btn" (click)="createMenuItem(MenuItemTypeEnum.Food)">
              <span class="hide_mobile">{{'MENU_ITEM.ADD_FOOD' | translate}}</span>
            </button>
          </span>
          <span class="show_mobile_inline">
            <button class="create_btn" (click)="menu.toggle($event)">
              <i class="pi pi-plus-circle"></i>
              <p-menu #menu class="header-menu menu-item-mobile-menu" [popup]="true" [model]="mobileMenuOptions" [autoZIndex]="false"></p-menu>
            </button>
          </span>
        </div>
    </div>
    <div class="pos-description-header">
      <label>{{'MENU_ITEM.ADD_MENU_ITEM_MESSAGE' | translate}}</label>
    </div>
    <div class="w-100 d-flex flex-row justify-content-between mt-3">
      <div class="p-input-icon-left w-100">
        <i class="pi pi-search"></i>
        <input type="text" class="menu_items_search" pInputText placeholder="{{'MENU_ITEM.SEARCH_MESSAGE' | translate}}" [(ngModel)]="searchTerm" (ngModelChange)="searchTermChange()"/>
      </div>
      <div class="menu_type_dropdown w-25">
        <p-multiSelect [options]="menuItemTypesOptions" [(ngModel)]="selectedMenuItemTypes"
                       defaultLabel="{{'MENU_ITEM.TYPE_DROPDOWN_PLACEHOLDER' | translate}}" optionLabel="name"
                       optionValue="id" [showHeader]="false">
        </p-multiSelect>
      </div>

    </div>
    <div class="cards_div_wrapper">
      <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
      <ng-container *ngIf="!spinner">
        <ng-container *ngIf="listAllFoodMenuItems.length > 0 && (selectedMenuItemTypes.length === 0 || selectedMenuItemTypes.includes(MenuItemTypeEnum.Food))">
          <span class="w-100 lbl_top ms-2">{{'MENU_ITEM.FOOD' | translate}}</span>
          <div *ngFor="let menuItems of listFilteredFoodMenuItems" class="div_card_category">
            <div>
              <img class="ctg_image" [src]="determineImageUrl(menuItems.pictureURL)">
              <div class="items_dropdown_helper pe-0 pt-0" #icon (click)="menu.toggle($event)"></div>
              <i class="pi pi-ellipsis-v spam_menu_ctg pe-0 pt-0" (click)="icon.click()"></i>
              <p-menu #menu class="edit-menu header-menu" [popup]="true" [model]="items[menuItems.id]"></p-menu>
            </div>
            <div class="div_ctg_lbl">
              <div class="d-flex text-start">
                <label class="ctg_lbl w-100" title="{{menuItems.name}}">{{menuItems.name}}</label>
              </div>
              <div class="d-flex text-start justify-content-between">
                <label class="ctg_lbl fw-400" title="{{menuItems.description}}">{{menuItems.description}}</label>
                <label class="ctg_lbl" title="{{menuItems.price}}">{{menuItems.price}} {{menuItems.currency ? menuItems.currency.symbol : ''}}</label>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="listAllDrinksMenuItems.length > 0 && (selectedMenuItemTypes.length === 0 || selectedMenuItemTypes.includes(MenuItemTypeEnum.Drink))">
          <span class="w-100 lbl_top ms-2">{{'MENU_ITEM.DRINKS' | translate}}</span>
          <div *ngFor="let menuItems of listFilteredDrinksMenuItems" class="div_card_category">
            <div>
              <img class="ctg_image" [src]="determineImageUrl(menuItems.pictureURL)">
              <div class="items_dropdown_helper pe-0 pt-0" #icon (click)="menu.toggle($event)"></div>
              <i class="pi pi-ellipsis-v spam_menu_ctg pe-0 pt-0" (click)="icon.click()"></i>
              <p-menu #menu class="edit-menu header-menu" [popup]="true" [model]="items[menuItems.id]"></p-menu>
            </div>
            <div class="div_ctg_lbl">
              <div class="d-flex text-start">
                <label class="ctg_lbl w-100" title="{{menuItems.name}}">{{menuItems.name}}</label>
              </div>
              <div class="d-flex text-start justify-content-between">
                <label class="ctg_lbl fw-400" title="{{menuItems.description}}">{{menuItems.description}}</label>
                <label class="ctg_lbl" title="{{menuItems.price}}">{{menuItems.price}} {{menuItems.currency ? menuItems.currency.symbol : ''}}</label>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
</div>
